export interface AlgoliaConfig {
	appId: string;
	readKey: string;
	suggestionsIndexNameUS: string;
	suggestionsIndexNameCA: string;
	productsIndexNameUS: string;
	productsIndexNameCA: string;
	/** Overrides Algolia's derived hosts — only for hermetic test envs. */
	customHostUrl?: string;
}

/**
 * Given the current environment, return the Algolia config
 * @returns AlgoliaConfig object
 * @throws Error if the Algolia config is not set
 */
export function loadAlgoliaConfig(): AlgoliaConfig {
	const {
		ALGOLIA_APP_ID,
		ALGOLIA_READ_KEY,
		ALGOLIA_SUGGESTIONS_INDEX_NAME_US,
		ALGOLIA_SUGGESTIONS_INDEX_NAME_CA,
		ALGOLIA_PRODUCTS_INDEX_NAME_US,
		ALGOLIA_PRODUCTS_INDEX_NAME_CA,
		ALGOLIA_CUSTOM_HOST_URL
	} = process.env;

	if (
		!ALGOLIA_APP_ID ||
		!ALGOLIA_READ_KEY ||
		!ALGOLIA_SUGGESTIONS_INDEX_NAME_US ||
		!ALGOLIA_SUGGESTIONS_INDEX_NAME_CA ||
		!ALGOLIA_PRODUCTS_INDEX_NAME_US ||
		!ALGOLIA_PRODUCTS_INDEX_NAME_CA
	) {
		throw new Error("ALGOLIA config is not set.");
	}

	return {
		appId: ALGOLIA_APP_ID,
		readKey: ALGOLIA_READ_KEY,
		suggestionsIndexNameUS: ALGOLIA_SUGGESTIONS_INDEX_NAME_US,
		suggestionsIndexNameCA: ALGOLIA_SUGGESTIONS_INDEX_NAME_CA,
		productsIndexNameUS: ALGOLIA_PRODUCTS_INDEX_NAME_US,
		productsIndexNameCA: ALGOLIA_PRODUCTS_INDEX_NAME_CA,
		customHostUrl: ALGOLIA_CUSTOM_HOST_URL || undefined
	};
}
